import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import CartModule from '../../cart/store/cartModule'

Vue.use(Vuex)

// called when the store is initialized
const initPlugin = store => {
    store.dispatch('cartModule/init');
};


const store = new Vuex.Store({
    state: {
        version: '1.0.0',
        isLoading: false,
        isSideBarMenuOpen: false
    },
    mutations: {
        SHOW_LOADER(state, value) {
            state.isLoading = value
        },
        TOGGLE_SIDEBAR_MENU(state) {
            state.isSideBarMenuOpen = !state.isSideBarMenuOpen;
        }
    },
    modules: {
        cartModule: CartModule
    },
    plugins: [initPlugin]
})

export default store